module.exports = __webpack_public_path__ + "img/Unidad20-3.0b4b50db.png";